var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGem4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 765.51,
    height: 1163.53,
    viewBox: "0 0 765.51 1163.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #b56f24;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#linear-gradient-26);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#linear-gradient-27);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#linear-gradient-28);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient-29);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#linear-gradient-30);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#linear-gradient-31);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#linear-gradient-32);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#linear-gradient-33);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#linear-gradient-34);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#linear-gradient-35);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#linear-gradient-36);\r\n      }\r\n\r\n      .cls-38 {\r\n        mask: url(#mask);\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: #d59c57;\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: url(#linear-gradient-37);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 428.19,
    y1: 79.76,
    x2: 420.68,
    y2: 121.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c69c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb03b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 475.18,
    y1: 487.03,
    x2: 436.44,
    y2: 495.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6976b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc66d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 517.18,
    y1: 847.78,
    x2: 569.87,
    y2: 847.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 445.82,
    y1: 362.32,
    x2: 474.53,
    y2: 356.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 594.24,
    y1: 651.72,
    x2: 571.63,
    y2: 629.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 557.82,
    y1: 673.75,
    x2: 577.45,
    y2: 692.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 630.8,
    y1: 598.99,
    x2: 650.2,
    y2: 621.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 714.28,
    y1: 672.88,
    x2: 679.13,
    y2: 695.91,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 640.32,
    y1: 825.1,
    x2: 765.51,
    y2: 825.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 561.84,
    y1: 916.41,
    x2: 647.45,
    y2: 916.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 621.52,
    y1: 812.46,
    x2: 597.48,
    y2: 821.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 613.97,
    y1: 807.53,
    x2: 627.18,
    y2: 801.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 589.55,
    y1: 745.46,
    x2: 581.08,
    y2: 733.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 639,
    y1: 698.13,
    x2: 612.95,
    y2: 713.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 628.46,
    y1: 697.89,
    x2: 652.72,
    y2: 685.8,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 647.09,
    y1: 761.58,
    x2: 673.04,
    y2: 761.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 516.75,
    y1: 1027.65,
    x2: 479.26,
    y2: 983.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6976b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fbc66d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 404.3,
    y1: 1065.41,
    x2: 460.89,
    y2: 1065.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 286.2,
    y1: 794.39,
    x2: 364.15,
    y2: 755.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 261.79,
    y1: 242.58,
    x2: 318.13,
    y2: 270.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 245.71,
    y1: 182.45,
    x2: 302.34,
    y2: 182.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 232.12,
    y1: 338.71,
    x2: 206.84,
    y2: 325.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 40.06,
    y1: 327.26,
    x2: 282.54,
    y2: 327.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 40.06,
    y1: 571.79,
    x2: 175.74,
    y2: 571.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 128.31,
    y1: 757.9,
    x2: 178.03,
    y2: 757.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 128.31,
    y1: 971.26,
    x2: 419.29,
    y2: 971.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 128.31,
    y1: 985.44,
    x2: 419.29,
    y2: 985.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 356.83,
    y1: 1126.79,
    x2: 419.29,
    y2: 1126.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0,
    y1: 1046.16,
    x2: 363.89,
    y2: 1046.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0,
    y1: 799.05,
    x2: 131.01,
    y2: 799.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 637.62,
    y1: 518.44,
    x2: 595.35,
    y2: 539.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 561.41,
    y1: 518.13,
    x2: 614.03,
    y2: 518.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 577.03,
    y1: 461.99,
    x2: 529.7,
    y2: 480.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 585.92,
    y1: 393.46,
    x2: 515.89,
    y2: 371.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 510.11,
    y1: 229.67,
    x2: 469.9,
    y2: 245.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 89.04,
    y1: 651.53,
    x2: 175.74,
    y2: 651.53,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -510.68,
    y: 101.99,
    width: 1510.92,
    height: 1007.28,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 406.08,
    y1: 93.11,
    x2: 448.7,
    y2: 93.11,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "406.08 84.15 408.27 102.08 448.7 84.31 406.08 84.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 949.35 86.94 655.87 131.01 662.38 40.06 481.2 245.71 170.27 302.34 178.54 389.37 0 406.08 84.15 448.7 84.31 575.73 373.42 552.43 396.72 582 492.62 614.03 460.6 667.5 582.41 765.51 770.22 463.64 1072.08 460.88 1066.54 404.3 1123.13 363.89 1163.53 0 949.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "389.37 0 371.61 137.24 531.43 941.85 561.85 973.88 389.37 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "569.87 903.41 561.85 973.88 517.18 721.69 536.86 729.5 569.87 903.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "524.65 684.19 517.18 721.69 389.37 0 524.65 684.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "621.46 587.38 664.17 574.81 517.18 721.69 524.65 684.19 621.46 587.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "600.94 665.42 605.88 633.05 517.18 721.69 536.86 729.5 600.94 665.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "626.92 639.44 605.88 633.05 664.17 574.81 640.41 625.95 626.92 639.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "765.51 770.22 711.36 761.91 640.41 625.95 664.17 574.81 765.51 770.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "765.51 770.22 647.45 888.28 640.32 832.96 711.36 761.91 765.51 770.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "614.34 858.94 647.45 888.28 561.85 973.88 569.87 903.41 614.34 858.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "568.21 746.61 589.74 746.61 647.45 888.28 614.34 858.94 568.21 746.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "594.16 720.66 589.74 746.61 647.45 888.28 640.32 832.96 594.16 720.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "568.21 746.61 594.16 720.66 589.74 746.61 568.21 746.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "600.94 665.42 605.88 633.05 652.13 745.44 647.09 777.72 600.94 665.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "626.92 639.44 673.04 751.77 652.13 745.44 605.88 633.05 626.92 639.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "647.09 777.72 673.04 751.77 652.13 745.44 647.09 777.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "475.81 997.46 463.64 1072.08 561.85 973.88 531.43 941.85 475.81 997.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "442.27 1022.7 460.88 1066.54 419.29 1108.13 404.3 1060.67 442.27 1022.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "475.81 997.46 463.64 1072.08 460.88 1066.54 442.27 1022.7 153.49 494.6 211 466.72 475.81 997.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "371.61 137.24 389.37 0 302.34 178.54 153.49 494.6 211 466.72 371.61 137.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "245.71 170.27 282.54 194.63 302.34 178.54 245.71 170.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "153.49 494.6 139.68 469.34 282.54 194.63 302.34 178.54 153.49 494.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "90.99 484.24 40.06 481.2 245.71 170.27 282.54 194.63 90.99 484.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "175.75 653.05 131.01 662.38 40.06 481.2 90.99 484.24 175.75 653.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "178.03 834.39 128.31 862.75 131.01 662.38 175.75 653.05 178.03 834.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "178.03 834.39 404.3 1060.67 419.29 1108.13 128.31 862.75 178.03 834.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "374.92 1090.05 419.29 1108.13 128.31 862.75 374.92 1090.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "356.83 1108.13 363.89 1163.53 419.29 1108.13 374.92 1090.05 356.83 1108.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "0 949.35 52.15 928.79 356.83 1108.13 363.89 1163.53 0 949.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "52.15 928.79 131.01 662.38 89.04 648.76 0 949.35 52.15 928.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "614.03 460.6 599.57 537.51 621.46 587.38 664.17 574.81 614.03 460.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "561.41 575.67 599.57 537.51 614.03 460.6 582 492.62 561.41 575.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "552.43 396.72 502.38 384.31 561.41 575.67 582 492.62 552.43 396.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "523.15 363.55 575.73 373.42 552.43 396.72 502.38 384.31 523.15 363.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "408.27 102.08 448.7 84.31 575.73 373.42 523.15 363.55 408.27 102.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "175.75 653.05 120.12 640.68 89.04 648.76 131.01 662.38 175.75 653.05"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M128.31,862.75l246.6,227.3-18.08,18.08L52.15,928.79l77.13-260.37ZM621.46,587.38l-21.89-49.87-38.16,38.16-59-191.36,20.76-20.77L408.27,102.08,524.65,684.19ZM282.54,194.64,91,484.24l84.75,168.82L178,834.39,404.3,1060.67l38-38L139.68,469.34ZM640.32,833l71-71.05-71-136-13.49,13.49L673,751.77l-25.95,26-46.15-112.3L536.86,729.5l33,173.91,44.47-44.47L568.21,746.61l25.95-26ZM232,423.6l-13.65,28L211,466.72l6.68,13.37,10.65,21.39L457.14,960.05l6.27,12.53,12.4,24.88,19.83-19.83,35.79-35.78L371.6,137.24Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "406.08 84.15 408.27 102.08 448.7 84.31 406.08 84.15"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem4);
export default __webpack_public_path__ + "static/media/gem4.0d0299839d1f0c1fa8d6001970e21514.svg";
export { ForwardRef as ReactComponent };